/** Normalize CustomEvent detail keys to server whitelist (snake_case). */
export function normalizeSwEventMeta(
  eventName: string,
  detail: Record<string, unknown>,
): Record<string, unknown> {
  const meta: Record<string, unknown> = { ...detail };
  if (meta.productId != null && meta.product_id == null) {
    meta.product_id = meta.productId;
  }
  delete meta.productId;
  if (meta.orderId != null && meta.order_id == null) {
    meta.order_id = meta.orderId;
  }
  delete meta.orderId;
  if (meta.categoryId != null && meta.category_id == null) {
    meta.category_id = meta.categoryId;
  }
  delete meta.categoryId;
  if (
    eventName === 'newsletter_offer_impression'
    || eventName === 'newsletter_modal_open'
    || eventName === 'newsletter_submit'
  ) {
    const surface = String(meta.surface ?? '').trim().slice(0, 64);
    return surface !== '' ? { surface } : {};
  }
  if (eventName === 'add_to_cart' || eventName === 'remove_from_cart') {
    const pid = meta.product_id;
    if (pid != null && pid !== '') meta.product_id = String(pid);
  }
  if (eventName === 'order_placed' && meta.order_id != null) {
    meta.order_id = String(meta.order_id);
  }
  if (eventName === 'search_result_click') {
    const out: Record<string, unknown> = {};
    if (meta.search_query != null) out.search_query = String(meta.search_query);
    if (meta.product_id != null && meta.product_id !== '') out.product_id = String(meta.product_id);
    if (meta.category_id != null && meta.category_id !== '') out.category_id = String(meta.category_id);
    if (Number.isFinite(Number(meta.position)) && Number(meta.position) > 0) out.position = Number(meta.position);
    return out;
  }
  if (eventName === 'search_results') {
    return {
      ...(meta.search_query != null ? { search_query: String(meta.search_query) } : {}),
      ...(Number.isFinite(Number(meta.result_count)) && Number(meta.result_count) >= 0
        ? { result_count: Number(meta.result_count) }
        : {}),
    };
  }
  if (eventName === 'checkout_validation_error') {
    return {
      ...(meta.step != null ? { step: String(meta.step) } : {}),
      ...(Number.isFinite(Number(meta.error_count)) && Number(meta.error_count) >= 0
        ? { error_count: Number(meta.error_count) }
        : {}),
      ...(Array.isArray(meta.fields) ? { fields: meta.fields.map(String) } : {}),
    };
  }
  if (eventName === 'checkout_attempt' || eventName === 'checkout_payment_open') {
    const id = String(meta.paymentid ?? '');
    return {
      ...(['login', 'signup', 'customer_data', 'payment', 'questionnaire', 'confirm'].includes(String(meta.step)) ? { step: String(meta.step) } : {}),
      ...(/^[1-9][0-9]{0,5}$/.test(id) ? { paymentid: Number(id) } : {}),
    };
  }
  if (eventName === 'checkout_submit') {
    return meta.step != null ? { step: String(meta.step) } : {};
  }
  if (eventName === 'checkout_exit') {
    const exitReason = String(meta.exit_reason ?? '');
    return {
      ...(meta.step != null ? { step: String(meta.step) } : {}),
      ...(['pagehide_after_submit', 'pagehide_without_submit'].includes(exitReason)
        ? { exit_reason: exitReason }
        : {}),
      ...(Number.isFinite(Number(meta.engagement_ms)) && Number(meta.engagement_ms) >= 0
        ? { engagement_ms: Number(meta.engagement_ms) }
        : {}),
    };
  }
  return meta;
}
